export const WEEKDAYS = [
  "Sunday",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
];

export const SHORT_MONTHS = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

export const MONTHS = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

export const FREQUENCY_OPTIONS = [
  "Once",
  "Daily",
  "Weekly",
  "Fortnightly",
  "Monthly",
  "Quarterly",
  "Half yearly",
  "Yearly",
];

export const SLOT_DATA = [
  { value: "10:00 AM - 12:00 PM", label: "10:00 AM - 12:00 PM" },
  { value: "12:01 PM - 15:00 PM", label: "12:01 PM - 03:00 PM" },
  { value: "15:01 PM - 18:00 PM", label: "03:01 PM - 06:00 PM" },
];
